import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {map, Observable} from "rxjs";
import {COMMON_MENU, IGNORE_VALIDATE_ROUTES, MAIN_MENU} from "../../../layout/sidebar/menu";
import {MenuItem} from "../../../layout/sidebar/menu.model";
import {UserUtilsService} from "../user/user-utils.service";
import {Router} from "@angular/router";
import {StorageKeysEnum} from "../../storage/storage-keys.enum";
import * as _ from "lodash";
import {SystemAuthenticationService,PermissionsLibService,PubsubKeyEnum} from "@monex-sistemas/nueva-banca-digital-library";
import {InternationalPermissionService} from "../permission/international-permission.service";
import {TranslateService} from "@ngx-translate/core";
import {MenuPermissionFactoryService} from "./permissions/menu-permission-factory.service";
import * as pubsub from "pubsub-js"

@Injectable({
    providedIn: 'root'
})
export class MenuService {
    baseEndpoint;
    private CONTRACT_MENU: MenuItem[] = MAIN_MENU;
    private showMonexUltraOption: boolean = false;
    private translateMessages: any;

    constructor(
        private httpClient: HttpClient,
        private userUtils: UserUtilsService,
        private router: Router,
        private systemAuthService: SystemAuthenticationService,
        private internationalPermissionService: InternationalPermissionService,
        private translateService: TranslateService,
        private menuPermissionFactoryService: MenuPermissionFactoryService,
        private permissionsLibService: PermissionsLibService
    ) {
        this.baseEndpoint = environment.apiUser;
        this.translateService.getTranslation(sessionStorage.getItem('CURRENT_LANGUAGE') ?? 'es').subscribe(messages => {
            this.translateMessages = messages;
        })
    }

    getMenu(contractId: string): Observable<any> {
        this.CONTRACT_MENU = [];
        const jwtWso2Decode: string | null = sessionStorage.getItem('JWT_WSO_DECODE');
        const jwtObj = JSON.parse(jwtWso2Decode ?? "{}");

        if ('ssoAppScope' in jwtObj && jwtObj.ssoAppScope == "forwards") {
            return this.httpClient.get("");
        }

        const contractSelected = this.userUtils.getUserContractInfoSessionStorage();
        const url = `${this.baseEndpoint}/menu/${contractId}`;

        return this.httpClient.get(url).pipe(
            map((responseMenu: any) => {
                const permissionsIdsFromMenu = this.permissionsLibService.extractMenuIds(responseMenu.menu)
                this.permissionsLibService.setContractPermissions(permissionsIdsFromMenu);
                pubsub.publish(PubsubKeyEnum.CHANGE_PERMISSIONS_MENU, permissionsIdsFromMenu)
                const menu = this.internationalPermissionService.validatePermissonsForNomina(contractSelected, responseMenu.menu);
                const mainMenu = _.cloneDeep(MAIN_MENU.map(x => ({...x})));
                let flattenMenu = menu.map(x => [x, ...x?.submenus]).flat();
                if (this.showMonexUltraOption) {
                    flattenMenu.push({
                        id: 'MONEX_ULTRA',
                        nombre: 'MONEX_ULTRA_MENU_OPTION',
                        label: `MONEX_ULTRA_LABEL`,
                        submenu: []
                    });
                }
                const publicMenu = this.buildBaseMenu();
                flattenMenu = this.mergeFullMenuWithPublicMenu(flattenMenu, publicMenu);
                let filteredMenu = mainMenu.filter(x => flattenMenu.some(y => y?.id == x?.id));
                const menuFilter = _.union(filteredMenu, publicMenu);
                for (const item of menuFilter) {
                    const menuItem = flattenMenu.find(m => m?.id == item?.id);
                    if (!menuItem) continue;
                    item.label = menuItem?.nombre;
                    if (item.items) {
                        for (const subItem of item?.items) {
                            const submenus = flattenMenu.find(fm => fm.id == item.id);
                            const subMenuItem = submenus?.submenus?.find(m => m?.id == subItem?.id);
                            if (!subMenuItem) {
                                const indexOf = item.items.indexOf(subItem);
                                item.items.splice(indexOf, 1);
                                continue;
                            }
                            subItem.label = subMenuItem?.nombre;
                        }
                    }
                }
                const permissionsMenu = menuFilter.filter(menu => {
                    if (menu.requirePermission && menu.permissionFunction && menu.permissionFunction != '') {
                        const permissionsFunc = this.menuPermissionFactoryService.getPermissionFunction(menu.permissionFunction);
                        return permissionsFunc ? permissionsFunc(contractSelected) : false;
                    }
                    return true;
                });
                this.CONTRACT_MENU = _.orderBy(permissionsMenu, ['order'], ['asc']);

            })
        );
    }


    mergeFullMenuWithPublicMenu(flattenMenu, publicMenu) {
        flattenMenu = _.union(flattenMenu, publicMenu);
        return _.map(flattenMenu, obj => {
            return _.mapKeys(obj, (value, key) => key === 'items' ? 'submenus' : key);
        });

    }

    getContractMenu() {
        return this.CONTRACT_MENU;
    }


    validateMenu(baseUrl: any) {
        const url = `/#${baseUrl}`
        if (sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN) != null
            && sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN_WSO) != null) {
            if (!IGNORE_VALIDATE_ROUTES.includes(url)) {
                setTimeout(() => {
                    let menuFound = false;

                    this.getContractMenu().forEach(menu => {
                        if (!menu?.url?.includes(url)) {
                            const found = menu?.items?.filter(item => item.url === url);
                            if (found && found.length >= 0) {
                                menuFound = true
                            }
                        } else {
                            menuFound = true
                        }
                    })
                }, 1000)
            }
        }
    }

    buildBaseMenu() {
        return COMMON_MENU;
    }

    setShowMonexUltraOption(value: boolean) {
        this.showMonexUltraOption = value;
    }

    getShowMonexUltraOption() {
        return this.showMonexUltraOption;
    }
}
